import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useCategories } from '../hooks/useCategories';
import CategoryIcon from './CategoryIcon';
import CategoriesSkeleton from './CategoriesSkeleton';

const CategoryGrid: React.FC = () => {
  const { t } = useTranslation();
  const { categories, loading } = useCategories();

  return (
    <div className="bg-surface-container-low py-16">
      <div className="max-w-container mx-auto px-4 md:px-margin-desktop">
        <h2 className="font-headline text-headline-sm text-on-surface mb-2 text-center">
          {t('home.browseByCategory')}
        </h2>
        <p className="text-on-surface-variant text-center mb-8">Encontre o que combina com seu ritmo</p>

        {loading ? (
          <CategoriesSkeleton />
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {categories.map(category => (
              <Link
                key={category.id}
                to={`/events?category=${category.slug}`}
                className="group bg-surface-container-lowest rounded-2xl shadow-sm border border-outline-variant/30 p-6 text-center hover:shadow-md hover:border-primary hover:bg-primary/5 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary/10 text-primary mb-3 mx-auto group-hover:scale-110 transition-transform">
                  <CategoryIcon
                    category={category.slug}
                    size={24}
                    className="mx-auto"
                  />
                </div>
                <h3 className="font-headline text-label-md text-on-surface group-hover:text-primary transition-colors">
                  {category.name}
                </h3>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryGrid;